import React from 'react'

function Earnings() {
  return (
    <div className="earnings">
      <p>Earnings content coming soon...</p>
    </div>
  )
}

export default Earnings
